(function () {
  'use strict';
  if (window.DeskyAccessoryCart) return;
  const core = window.DeskyAccessoriesCore;
  const root = window.Shopify?.routes?.root || '/';
  const strings = JSON.parse(document.getElementById('desky-accessory-strings').textContent);
  let busy = false, replaying = false;
  async function request(path, body) {
    const response = await fetch(root + path, {
      method: body ? 'POST' : 'GET', cache: 'no-store',
      headers: { Accept: 'application/json', ...(body ? { 'Content-Type': 'application/json' } : {}) },
      ...(body ? { body: JSON.stringify(body) } : {})
    });
    const data = await response.json();
    if (!response.ok || data.status >= 400) throw new Error(typeof data.description === 'string' ? data.description : strings.cartError);
    return data;
  }
  function report(message) {
    document.querySelectorAll('[data-desky-cart-error]').forEach(element => {
      element.textContent = message; element.hidden = !message;
    });
  }
  async function refresh(cart) {
    const url = new URL(location.href);
    url.searchParams.set('_desky_refresh', Date.now());
    const response = await fetch(url, { cache: 'no-store' });
    if (!response.ok) throw new Error(strings.refreshError);
    const html = new DOMParser().parseFromString(await response.text(), 'text/html');
    for (const selector of ['#carto', '#main-cart-items .js-contents', '#main-cart-footer .desky-cart-payment-slider', '.main-popup-cart-items', '#cart-icon-bubble']) {
      const current = document.querySelector(selector), next = html.querySelector(selector);
      if (current && next) current.innerHTML = next.innerHTML;
    }
    document.querySelectorAll('cart-items, #main-cart-footer').forEach(element => element.classList.toggle('is-empty', cart.item_count === 0));
    report(core.cartProblems(cart).length ? strings.incomplete : '');
    document.dispatchEvent(new CustomEvent('desky:cart-updated', { detail: { cart } }));
  }
  async function exclusive(work) {
    if (busy) throw new Error(strings.busy);
    busy = true; document.documentElement.setAttribute('data-desky-cart-busy', '');
    try { return await work(); }
    finally { busy = false; document.documentElement.removeAttribute('data-desky-cart-busy'); }
  }
  async function add(items, configuration) {
    return exclusive(async () => {
      // Read before any mutation. A failed preflight is safe to retry.
      await request('cart.js');
      let failure;
      try { await request('cart/add.js', { items }); } catch (error) { failure = error; }
      let cart;
      try { cart = await request('cart.js'); }
      catch (_) { const error = new Error(strings.cartError); error.uncertain = true; throw error; }
      const added = cart.items.filter(item => item.properties?._desky_configuration === configuration);
      try { await refresh(cart); }
      catch (_) { const error = new Error(strings.refreshError); error.uncertain = added.length > 0 || Boolean(failure); throw error; }
      if (failure || added.length !== items.length || core.cartProblems(cart).length) {
        const error = new Error(failure?.message || strings.incomplete);
        error.uncertain = added.length > 0;
        throw error;
      }
      if (typeof CartSlider === 'function') CartSlider();
      else location.assign(root + 'cart');
      return cart;
    });
  }
  async function change(configuration, delta, remove) {
    return exclusive(async () => {
      const cart = await request('cart.js');
      const group = cart.items.filter(item => item.properties?._desky_configuration === configuration);
      const parent = group.find(item => item.properties._desky_role === 'parent');
      if (!group.length) { await refresh(cart); return; }
      if (!remove && !parent) throw new Error(strings.incomplete);
      const quantity = remove ? 0 : parent.quantity + delta;
      if (!Number.isSafeInteger(quantity) || quantity < 1 && !remove) return;
      let next = cart;
      const findLine = reference => next.items.findIndex(item =>
        item.properties?._desky_configuration === configuration &&
        item.properties._desky_role === reference.properties._desky_role &&
        item.properties._desky_group === reference.properties._desky_group);
      async function setQuantity(reference, value) {
        const index = findLine(reference);
        if (index < 0) { if (value === 0) return; throw new Error(strings.incomplete); }
        if (next.items[index].quantity === value) return;
        // change.js validates inventory; update.js permits existing lines above stock.
        // Resolve each position from the latest response, including nested children.
        next = await request('cart/change.js', { line: index + 1, quantity: value });
        const updatedIndex = findLine(reference);
        if (value > 0 && (updatedIndex < 0 || next.items[updatedIndex].quantity !== value)) throw new Error(strings.cartError);
      }
      let failure;
      try {
        for (const item of group) await setQuantity(item, quantity);
      } catch (error) {
        failure = error;
        next = await request('cart.js');
        if (!remove) {
          // Undo only successful increases, never increase stock during recovery.
          // If recovery fails, reconciliation below keeps checkout blocked.
          for (const item of group) {
            const index = findLine(item);
            if (index >= 0 && next.items[index].quantity > item.quantity) {
              try { await setQuantity(item, item.quantity); } catch (_) { next = await request('cart.js'); }
            }
          }
        }
      }
      next = await request('cart.js');
      await refresh(next);
      if (core.cartProblems(next).length) throw new Error(strings.incomplete);
      if (failure) throw failure;
    });
  }
  document.addEventListener('click', async event => {
    const control = event.target.closest('[data-desky-delta],[data-desky-remove]');
    if (!control) return;
    event.preventDefault(); event.stopImmediatePropagation();
    const configuration = control.closest('[data-desky-configuration]').dataset.deskyConfiguration;
    try { await change(configuration, Number(control.dataset.deskyDelta || 0), control.hasAttribute('data-desky-remove')); }
    catch (error) { report(error.message || strings.cartError); }
  }, true);
  async function checkout(event, target, resume) {
    if (replaying || !document.querySelector('[data-desky-configuration]')) return;
    event.preventDefault(); event.stopImmediatePropagation();
    if (busy) { report(strings.busy); return; }
    try {
      await exclusive(async () => {
        const cart = await request('cart.js');
        if (core.cartProblems(cart).length) throw new Error(strings.incomplete);
      });
      replaying = true;
      try { resume(); } finally { replaying = false; }
    } catch (error) {
      report(error.message || strings.cartError);
      document.querySelector('[data-desky-cart-error]:not([hidden])')?.focus();
    }
  }
  document.addEventListener('click', event => {
    const target = event.target.closest('[name="checkout"],a[href*="/checkout"]');
    if (target) checkout(event, target, () => target.click());
  }, true);
  document.addEventListener('submit', event => {
    if (event.submitter?.name === 'checkout') checkout(event, event.target, () => event.target.requestSubmit(event.submitter));
  }, true);
  window.DeskyAccessoryCart = { add, change, refresh };
})();
